import './main.less';
import React from 'react';
import cn from 'classname';
import _groupBy from 'lodash/groupBy';
import _get from 'lodash/get';
import _sumBy from 'lodash/sumBy';
import _orderBy from 'lodash/orderBy';
import withCheckPermission from '../../../../shared/check-permission-hoc';
import Row from './row';

const Table = (props) => {
	const { check, intl, data, groupColumns, table, groupsSelectValues } = props;
	const rows = data || [];

	return (
		<table className="stat-table">
			<Thead
				{...props}
				check={check}
				groupsSelectValues={groupsSelectValues}
				groupColumns={groupColumns}
				intl={intl}
				table={table}
			/>
			<tbody
				className={cn({
					'stat-table__body': true,
					'table-indexing': true,
					'statistics-table-indexing': true
				})}
			>
				{getRows({...props, rows })}
			</tbody>
		</table>
	);
};

const getRows = (props) => {
	let { rows, groupsSelectControls: { first, second }, sort } = props;
	let index = 0;
	const [ , secondCol ] = [first, second].map(i => _get(i, 'value.0.label'));
	const [ firstColVal, secondColVal ] = [first, second].map(i => _get(i, 'value.0.value'));
	const markupRows = [];
	const sortInternal = sort.sortInternal || {};

	if (!secondColVal) {
		rows = sortInternal.index
			? _orderBy(rows, [sortInternal.index], [sortInternal.direction])
			: rows;

	}

	const groupedByMainCol = _groupBy(rows, r => r[firstColVal]);
	const isGroupedByReason = secondColVal === 'cancellation_reason';

	let mainColGroupEntries = Object.entries(groupedByMainCol);

	for (const [grpKey, grpVal] of mainColGroupEntries) {
		const rowsInternalSort = sortInternal.index
			? _orderBy(grpVal, [sortInternal.index], [ sortInternal.direction ])
			: grpVal;

		if (secondCol) {
			markupRows.push(
				<tr className="group-header" key={index++}>
					<td colSpan={isGroupedByReason ? '7' : '9'}>
						<div className="group-header__wrap">
							<span className="title">{grpKey || 'Отсутствует'}</span>
						</div>
					</td>
				</tr>
			);
		}

		for (const row of rowsInternalSort) {
			if (isGroupedByReason && row.cancellation_reason === null) {
				continue;
			}
			markupRows.push(<Row {...props} row={row} isGroupedByReason={isGroupedByReason} key={index++}/>);
		}
		if (isGroupedByReason) {
			markupRows.push(
				<tr key={index++}>
					<td colSpan={7}>
						<div className="group-header__wrap">
							<span className="title">
								<b>Valid: </b>
								{_sumBy(grpVal, row => Number(row['valid_count']))}
							</span>
							<span>{'      '}</span>
							<span className="title">
								<b>Total: </b>
								{_sumBy(grpVal, row => Number(row['total_count']))}
							</span>
						</div>
					</td>
				</tr>
			);
		}
	}

	return markupRows;
};

const Thead = ({
	intl,
	groupsSelectValues,
	sort,
	toggleSortMain,
	groupsSelectControls,
	toggleSortAdditional,
	toggleSortInternal,
	groupColumns
}) => {
	const { first, second } = groupsSelectControls;
	const [ firstCol, secondCol ] = [first, second].map(i => _get(i, 'value.0.label'));
	const [ firstColVal, secondColVal] = [first, second].map(i => _get(i, 'value.0.value'));
	const isGroupedByReason = secondColVal === 'cancellation_reason';

	const sortMain = sort.sortMain || {};
	const sortAdditional = sort.sortAdditional || {};
	const sortInternal = sort.sortInternal || {};

	const secondGroupTitle = _get(groupColumns, `${groupsSelectValues[1]}.title`, null);

	return (
		<thead className="stat-table__head">
			<tr className="stat-table__head-top font-roboto-medium">
				<th
					rowSpan={secondCol ? 2 : 1}
					className="group-header--first"
				>
					<p
						className={cn({
							'order': true,
							[`order-direction--${sortMain.direction}`]: sortMain.direction
						})}
						onClick={toggleSortMain.bind(null, firstColVal)}
					>
						<span>{firstCol}</span>
					</p>
					{
						secondGroupTitle &&
						<p
							className={cn({
								'border-top-1': true,
								'order': true,
								[`order-direction--${sortAdditional.direction}`]: sortAdditional.direction
							})}
							onClick={toggleSortAdditional.bind(null, secondColVal)}
						>
							<span>{secondCol}</span>
						</p>
					}
				</th>
				{
					!isGroupedByReason &&
					<th
						onClick={toggleSortInternal.bind(null, 'valid_count')}
						className={cn({'hover-pointer': true, 'bg-sort': sortInternal.index === 'valid_count'})}
					>
						<span>{intl('Valid')}</span>
					</th>
				}
				<th
					onClick={toggleSortInternal.bind(null, 'rejected_count')}
					className={cn({'hover-pointer': true, 'bg-sort': sortInternal.index === 'rejected_count'})}
				>
					<span>{intl('Rejected')}</span>
				</th>
				<th
					onClick={toggleSortInternal.bind(null, 'trash_count')}
					className={cn({'hover-pointer': true, 'bg-sort': sortInternal.index === 'trash_count'})}
				>
					<span>{intl('Trash')}</span>
				</th>
				<th
					onClick={toggleSortInternal.bind(null, 'rejected_and_trash_count')}
					className={cn({'hover-pointer': true, 'bg-sort': sortInternal.index === 'rejected_and_trash_count'})}
				>
					<span>{intl('Rejected + Trash')}</span>
				</th>
				{
					!isGroupedByReason &&
					<th
						onClick={toggleSortInternal.bind(null, 'total_count')}
						className={cn({'hover-pointer': true, 'bg-sort': sortInternal.index === 'total_count'})}
					>
						<span>{intl('Total')}</span>
					</th>
				}
				<th
					onClick={toggleSortInternal.bind(null, 'rejected_to_valid')}
					className={cn({'hover-pointer': true, 'bg-sort': sortInternal.index === 'rejected_to_valid'})}
				>
					<span>{intl('Reject from Valid, %%')}</span>
				</th>
				<th
					onClick={toggleSortInternal.bind(null, 'trash_to_valid')}
					className={cn({'hover-pointer': true, 'bg-sort': sortInternal.index === 'trash_to_valid'})}
				>
					<span>{intl('Trash from Valid, %%')}</span>
				</th>
				<th
					onClick={toggleSortInternal.bind(null, 'trash_to_total')}
					className={cn({'hover-pointer': true, 'bg-sort': sortInternal.index === 'trash_to_total'})}
				>
					<span>{intl('Trash from Total, %%')}</span>
				</th>
			</tr>
			{
				secondGroupTitle &&
				<tr className="height-40">
				</tr>
			}
		</thead>
	);
};

export default withCheckPermission(Table);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/table/invalid/main.js